import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Carousel3d from 'vue-carousel-3d'
import 'animate.css'
import '@/common/css/bootstrap.min.css'
//图片懒加载
import VueLazyload from 'vue-lazyload'
//引入element-ui的全部组件
import ElementUI from 'element-ui'
//引入element-ui的css
import 'element-ui/lib/theme-chalk/index.css'
//使用elementUI
Vue.use(ElementUI)
Vue.use(VueLazyload)

// import 'modernizr';
Vue.config.productionTip = false
Vue.use(Carousel3d)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
